<template>
  <div class="zoon" v-if="list">

    <div class="list" v-for="(course_item,index) in course_list" :key="course_item.cate_id+'_'+index">
      <div class="hot_course_list">
        <div class="tit">
          <span class="t1">{{course_item.course_name}}</span>
          <span class="t2">{{course_item.course_other_name}}</span>

          <div class="t3" @click="onGoMore(course_item)">
            <span>查看更多</span>
            <i class="el-icon-more"></i>
          </div>
        </div>

        <el-carousel height="420px" :autoplay="false" :loop="false" >
          <el-carousel-item v-for="(item, index) in course_item.f_course_lesson" :key="item.lesson_name+'_'+index">
            <div class='item' v-for="(sub,index) in item" :key="sub.id+'_'+index">
            
              <div class="tit_name">
                <span class="f1">{{sub.lesson_name}}</span>
                <span class="f2">{{sub.lesson_short_desc}}</span>
              </div>
              <div class="tit_info">
                <div class="imgbox" @click="onLook(sub.course_id,sub.id)">
                  <img :src="sub.lesson_image" alt="" >
                  <div class="playBtn">
                    <a href="#" title="start">start</a>
                  </div>
                </div>
                <div class="info">
                  <div class="l l1"><i class="el-icon-view"></i>总观看数 <span>{{sub.view_count > 100000 ? sub.view_count+'W+' : sub.view_count}}</span> </div>
                  <div class="l l2"><i class="el-icon-time"></i>总观时长 <span>{{sub.view_times_total > 100000 ? sub.view_times_total+'W+' : sub.view_times_total}}</span> </div>
                  <div class="l l3"><i class="el-icon-user"></i>科目学员数 <span>{{sub.view_member_count > 100000 ? sub.view_member_count+'W+' : sub.view_member_count}}</span> </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'zoon',
  data:function () {
    return {
      list:null,
      course_list:null,
    }
  },
  created(){
    this.fetch();
  },
  watch: {
		// '$route' (to, from) {
    '$route' () {
      // console.log("route :",to,from,this.$route);
      this.fetch();
		}
	},
  methods:{
   async fetch(){
     let list = await this.$fly.get('/course/courseList',{ cate_id: this.$route.params.id });

    //测试
    // for (var j=0;j<list.data.length;j++){
    //   for (let i = 0; i < 20; i++) {
    //     list.data[j].course_lesson.push(list.data[j].course_lesson[0])
    //   }
    // }


     //课程集数
     let course_list = list.course_list.data;
     for (let j=0;j<course_list.length;j++){
      course_list[j].f_course_lesson = [];

      for (let i = 0; i < course_list[j].course_lesson.length; i++) {
        let f = parseInt(i/6);
        
        if (course_list[j].f_course_lesson[f]){
          course_list[j].f_course_lesson[f].push(course_list[j].course_lesson[i]);
        }else{
          course_list[j].f_course_lesson[f] = [];
          course_list[j].f_course_lesson[f].push(course_list[j].course_lesson[i]);
        }
      }
     }
    

     this.list = list;
     this.course_list = course_list;
     this.$store.state.bannerlist = this.list.course_cate.banners;
     console.log("this.list:",this.list);
     
   },
   onGoMore(info){
     console.log("更多:",info);
     this.$router.push({ name: 'Class', params: { id: info.id }})
   },
   onLook(course_id,course_lesson_id){
    console.log("播放的课程id:",course_id,", 章节id:",course_lesson_id);
    
    this.$router.push({ name: 'Look', params: { id: course_id, course_lesson_id:course_lesson_id}})
  },
  }
}
</script>

<style lang='scss'>

.zoon{

  .list:nth-child(2n) {
    background-color: #EFEEEE;;
  }

  .list{
    padding: 20px 0;
  }

  .hot_course_list{
    width:1024px;
    margin: 30px auto 0;
   
    .tit{
      position: relative;
      background-color:#fff;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding:10px 14px;
      border-radius: 5px;
      display:flex;
      align-items:baseline;

      .t1{
        font-size: 20px;
        color: #00B3A4;
      }

      .t2{
        font-size: 16px;
        color: #B3B3B3;
        margin-left:20px;
      }

      .t3{
        position: absolute;
        right: 20px;
        top: 15px;
        font-size: 10px;
        color: #999;
        cursor: pointer;

        i{
          margin-left: 10px;
        }
      }
    }

    .el-carousel{
      margin-top:20px;
    }

    .el-carousel__arrow{
      display: none;
    }

    .el-carousel__button{
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #CCC;
    }

    .is-active button {
      background-color: #999;
      width: 40px;
      
    }
  }

  .item:nth-child(3n) {
     margin-right: 0;
  }

  .item{
    width:306px;
    height:146px;
    background-color:#fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    padding:10px 0;
    border-radius: 5px;
    text-align: left;
    margin-right: 52px;
    display: inline-block;
    margin-bottom: 20px;

    .tit_name{
      display:flex;
      align-items:center;

      .f1{
        width:25%;
        height:35px;
        line-height:35px;
        background-color:#00B3A4;
        color:#fff;
        font-size:16px;
        overflow:hidden;
        padding: 0 6px;
        font-weight: bold;
      }

      .f2{
        width:60%;
        height:35px;
        line-height:35px;
        color:#000;
        font-size:16px;
        overflow:hidden;
        margin-left:6px;
      }

    }

    .tit_info{
      display:flex;
      align-items:center;

      .imgbox{
        width:158px;
        height:106px;
        margin-top: 6px;
        margin-left: 6px;
        cursor: pointer;
        position: relative;

        img{
          width:158px;
          height:106px;
        }

        .playBtn{ 
          position: absolute; 
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          height: 50px; 
          width:50px; 
          -webkit-border-radius: 100%; 
          -moz-border-radius: 100%; 
          -o-border-radius: 100%; 
          border-radius: 100%; 
          margin: auto; 
          background-color: rgba(115, 133, 159, 0.5);
          border: 2px solid #fff; 

          a { 
            border-color: transparent transparent transparent #fff; 
            border-width: 8px 0 8px 12px;  
            width: 0; height: 0; 
            border-style: solid;
            text-indent: -9999px; 
            position: absolute; 
            top: 16px;
            left: 21px; 
          }
        }
      }

      .info{
        font-size:12px;
        color: #808080;
        margin-left:8px;
        width:130px;

        .l{
          display:flex;
          align-items:center;
          margin: 6px 0;

          i{
            color:#00B3A4;
            margin-right:8px;
          }

          span{
            margin-left:8px;
          }
        }
        
      }
    }
  }
  
}

</style>